import { SectionHeader } from "@/components/sections/SectionHeader";
import { TrendingDown, Clock, Cpu, PiggyBank } from "lucide-react";
import { motion } from "framer-motion";
import { fadeInUp, staggerContainer, viewportConfig } from "@/lib/animations";

const outcomes = [
  {
    icon: TrendingDown,
    title: "Reduction in Operational Overhead",
  },
  {
    icon: Clock,
    title: "Faster Management Decision Cycles",
  },
  {
    icon: Cpu,
    title: "AI Adoption Without Increasing Headcount",
  },
  {
    icon: PiggyBank,
    title: "Hidden Margin Recovered Through Process Redesign",
  },
];

export const ProofSection = () => {
  return (
    <motion.section
      className="section-padding bg-background"
      initial="hidden"
      whileInView="visible"
      viewport={viewportConfig}
      variants={staggerContainer}
    >
      <div className="section-container">
        <motion.div variants={fadeInUp}>
          <SectionHeader
            eyebrow="Proof Without Noise"
            title="Representative Engagement Outcomes"
          />
        </motion.div>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8"
          variants={staggerContainer}
        >
          {outcomes.map((outcome, index) => (
            <motion.div
              key={index}
              className="border border-border p-8 text-center"
              variants={fadeInUp}
              whileHover={{ y: -4, transition: { duration: 0.25 } }}
            >
              <outcome.icon size={28} className="text-primary mx-auto mb-4" />
              <p className="font-serif text-lg md:text-xl font-medium text-foreground">
                {outcome.title}
              </p>
            </motion.div>
          ))}
        </motion.div>

        <motion.p
          className="font-sans text-xs text-center text-muted-foreground italic"
          variants={fadeInUp}
        >
          Examples shown are representative of engagements led by Inductus leadership and consulting frameworks.
        </motion.p>
      </div>
    </motion.section>
  );
};
